import { Url, IUrl, ScriptLoader, Singleton } from 'app/utils';
import { Application, $Constants, $CurrentUser, $Router, $Analytics } from 'app/classes';
import { $IdentityResource } from 'app/resources';
import { IdentityService, $RavenService, intercomService, googleAnalyticsService } from 'app/services';

export class CommercePlatform {

    public ngLoaded = false;
    public ngLoading = false;

    public init(): void {

        $Analytics.registerServices([
            intercomService,
            googleAnalyticsService
        ]);
        $Analytics.initServices();

        $IdentityResource.setEnvironment($Constants.env);

        this.registerPublicApps();

        $CurrentUser.startSession()
            .catch(() => {}) // noop for no session
            .finally($Router.gotoSavedRoute);

        $CurrentUser.onLogin(() => {
            this.loadAngularApp();
            $RavenService.setupUser($CurrentUser);
            $CurrentUser.apps.forEach($Router.registerApp);
            $Analytics.setUser($CurrentUser);
            $Router.broadcast('userAuthenticated', {token: $CurrentUser.token});
        });

        $CurrentUser.onLogout(() => {
            $Router.broadcast('userUnauthenticated');
            $Router.unregisterApps();

            // If the user does not have the correct org token, we want to retain
            // her savedRoute so that we can send her to it once she has the
            // correct org token.
            if($CurrentUser.hasCorrectOrgToken()) {
                $Router.saveRoute();
            }

            // Determines if the url contains an org_id query param
            const currentUrl = Url.getCurrent();
            const currentUrlObj = Url.parse(currentUrl);
            const searchObj = Url.parseSearch(currentUrlObj.search);
            const orgId = searchObj['cp.orgid'];
            const orgId_queryParam = orgId ? `&cp.orgid=${orgId}` : '';
            $Router.goto(`auth/login?${orgId_queryParam}`);
        });
    }

    /**
     * Load the Angular portion of our application. This is deferred until the
     * user is logged in to save on load times.
     */
    public loadAngularApp(): void {
        if (!this.ngLoaded && !this.ngLoading) {
            this.ngLoading = true;
            const cdn = $Constants.cdnAssets;
            ScriptLoader.loadScripts([
                Url.join(cdn, '/libs/angular.js/1.5.11/angular.min.js?cache=none'),
                Url.join(cdn, 'libs/fontfaceobserver/2.0.7/fontfaceobserver.min.js'),
                Url.join($Constants.buildUrl, 'app/ng.min.js')
            ]).then(() => {
                this.ngLoaded = true;
            }).finally(() => {
                this.ngLoading = false;
            });
        }
    }

    private registerPublicApps() {
        const apps = $Constants.apps || [];
        apps.forEach((appDefinition) => {
            $Router.registerApp(new Application(appDefinition));
        });
    }

}

export let $CommercePlatform = Singleton('$CommercePlatform', CommercePlatform);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./public/app/main.ts